import { AuthEventHandler, AuthStrategy } from '../types'
import { AuthMethod } from './base'

export interface LocalStorageAuthOptions {
  localStorageKey: string
}

export class LocalStorageAuth extends AuthMethod {
  tokenIdentifier = 'Token'
  key: string

  constructor(options?: LocalStorageAuthOptions, eventHandler?: AuthEventHandler) {
    super(eventHandler)
    this.key = options?.localStorageKey ?? 'AUTH_TOKEN'
  }

  private getToken() {
    return localStorage.getItem(this.key) ?? undefined
  }

  use = () => {
    this.token = this.getToken()
    return this.token !== undefined
  }
  init = () => {
    this._eventHandler('authenticated')
  }
  expiringSoon = (): boolean => false
  refresh = async (): Promise<AuthStrategy | undefined> => {
    const token = localStorage.getItem(this.key)
    if (!token) return undefined
    return new AuthStrategy(this.tokenIdentifier, token)
  }
  login = async () => {
    throw new Error('Login not supported for LocalStorageAuth')
  }
  logout = async () => {
    localStorage.removeItem(this.key)
    location.reload()
  }
}
